var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16PxChemistry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-color": "color-2",
    x: 3,
    width: 10,
    height: 3,
    rx: 0.5,
    fill: "#444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.816V4h-5v4.816l-3.23 3.818a2.085 2.085 0 0 0-.449 1.952A1.988 1.988 0 0 0 3.734 16h8.532a1.988 1.988 0 0 0 1.913-1.414 2.088 2.088 0 0 0-.448-1.952Z",
    fill: "#444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16PxChemistry);
export default __webpack_public_path__ + "static/media/16px_chemistry.359ca938e16baa4cb2698c6401f8808c.svg";
export { ForwardRef as ReactComponent };